import { Routes, Route, BrowserRouter } from "react-router-dom";
import AboutPage from "../pages/about/AboutPage";
import ContactPage from "../pages/contact/ContactPage";
import HomePage from "../pages/home/HomePage";
import ProjectsPage from "../pages/projects/ProjectsPage";
import RandomPasswordGeneratorPage from "../pages/random-password-generator/RandomPasswordGeneratorPage";
import TicTacToePage from "../pages/tic-tac-toe/TicTacToePage";
import InvestmentPortfolioPage from "../pages/investment-portfolio/InvestmentPortfolioPage";
import RetirementCalculatorPage from "../pages/retirement-calculator/RetirementCalculatorPage";
import CalculatorPage from "../pages/calculator/CalculatorPage";
import Layout from "../layouts/Layout";
import SolarPage from "../pages/solar/SolarPage";
import ToolsPage from "../pages/tools/ToolsPage";
import VINDetailsFinderPage from "../pages/vin-details-finder/VINDetailsFinderPage";
import TestPage from "../pages/test/TestPage";

export default function AppRoutes(): JSX.Element {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          {/* namespace / */}
          <Route index element={<HomePage />} />
          <Route path={"about"} element={<AboutPage />} />
          <Route path={"contact"} element={<ContactPage />} />
          <Route path={"test"} element={<TestPage />} />
          {/* end namespace / */}

          <Route path={"projects"} element={<ProjectsPage />} />

          {/* namespace /tools */}
          <Route path={"tools"}>
            <Route index element={<ToolsPage />} />
            <Route
              path={"random-password-generator"}
              element={<RandomPasswordGeneratorPage />}
            />
            <Route path={"tic-tac-toe"} element={<TicTacToePage />} />
            <Route
              path={"investment-portfolio"}
              element={<InvestmentPortfolioPage />}
            />
            <Route
              path={"retirement-calculator"}
              element={<RetirementCalculatorPage />}
            />
            <Route path={"calculator"} element={<CalculatorPage />} />
            <Route path={"solar"} element={<SolarPage />} />
            <Route
              path={"vin-details-finder"}
              element={<VINDetailsFinderPage />}
            />
          </Route>
          {/* end namespace /projects */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
